import { GameEventsManager } from '@hexa/gameEvents/GameEventsManager';
import type { BoardModel } from '@hexa/game/boardMVC/models/board/BoardModel';
import type { BoardView } from '@hexa/game/boardMVC/views/board/BoardView';
import type { Container } from 'pixi.js';
import { getLongPlayAdScheduler } from '../ads/longPlayAdScheduler';

/** AZ-998: tells the long-play ad scheduler when a level is actually being played. */
export class AzerionGameEventsManager extends GameEventsManager {
  public setupInGameHandlers(boardModel: BoardModel, boardView: BoardView): void {
    getLongPlayAdScheduler().setLevelActive(true);
    super.setupInGameHandlers(boardModel, boardView);
  }

  public onLevelWon(): void {
    getLongPlayAdScheduler().setLevelActive(false);
    super.onLevelWon();
  }

  public onLevelLost(): void {
    getLongPlayAdScheduler().setLevelActive(false);
    super.onLevelLost();
  }

  public startMainMenuFlow(lifeCycleObject: Container): Promise<void> {
    getLongPlayAdScheduler().setLevelActive(false);
    return super.startMainMenuFlow(lifeCycleObject);
  }
}
